var React = require('react');

function Add (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#424242","fillRule":"evenodd","d":"M12.5 11.5h7a.5.5 0 1 1 0 1h-7v7a.5.5 0 1 1-1 0v-7h-7a.5.5 0 1 1 0-1h7v-7a.5.5 0 1 1 1 0v7z"}));
}

Add.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Add;

Add.default = Add;
